"use client";
import { usePageState } from "@/Context/PageState";
import style from "@/styles/ServiceForm.module.scss";
import { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import $ from "jquery";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import Image from "next/image";
import OrangeSpan from "@/Ui_Elements/OrangeSpan/OrangeSpan";

const ServiceForm = () => {
  const {
    register,
    trigger,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({ mode: "all" });

  const submitBtn = useRef(null);

  const [isValidNum, setIsValidNum] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState("");
  const { CommonSubmitForm, CommonValidateForm, getCountryCode, countryCode, onloadCallback } = usePageState();
  const effectRan = useRef(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    const values = getValues();
    // Clean up the phone number before submission
    if (values.mobile && values.mobile.startsWith("0")) {
      values.mobile = values.mobile.substring(1);
    }
    values.mobile = values.mobile.replace(/[\(\)\-]/g, "");
    triggerValidation();

    if (CommonValidateForm(2) == true && isValidNum) {
      CommonSubmitForm(2, values);
      setPhoneNumber(""); // Reset phone number after submission
    } else {
      triggerValidation();
    }
  };

  const triggerValidation = () => {
    trigger(); // all fields
  };

  const onChange = (isValid, rawValue) => {
    const containsOnlyNumbers = /^\d+$/.test(rawValue);
    if (containsOnlyNumbers) {
      setIsValidNum(isValid);
      setPhoneNumber(rawValue);
      setValue("mobile", rawValue);
    } else {
      if (!rawValue) {
        setIsValidNum(isValid);
        setPhoneNumber(rawValue);
        setValue("mobile", rawValue);
      }
    }
  };

  useEffect(() => {
    getCountryCode();
    if (effectRan.current === false) {
      $(document).on("focus blur change", ".service-form input, .service-form textarea", function () {
        $(this).val($(this).val().replace(/^\s+/, ""));
      });

      return () => {
        effectRan.current = true;
      };
    }
  }, []);

  return (
    <section className={`${style["contactusformmaindiv"]}`}>
      <div className="container">
        <div className={`${style["newpartfull"]}`}>
          <div className={`${style["sectionheading"]}`}>
            <OrangeSpan text={`Contact Us`} classname={`${style["badge"]}`} />
            <h3
              className={`${style["commonsectiontitle"]} commonsectiontitle`}
            >{`Transform Your Vision into Reality – Let’s Digitize Your Future!`}</h3>
          </div>
          <div className={`${style["contactformbody"]}`}>
            <div className={`${style["left"]}`}>
              <div className={`${style["lefttop"]} ${style["bgcard"]}  ${style["contentpart"]}`}>
                <div className={`${style["imagebox"]} `}>
                  <Image src={"/images/contact_us.png"} alt="image" width={0} height={0} />
                </div>
              </div>
            </div>
            <div className={`${style["right"]} ${style["bgcard"]}  ${style["bgcardpattrent"]} `}>
              <form
                id="service-form"
                autoComplete="off"
                className={`${style["formmain"]} commonformclass service-form commonform`}
              >
                <h1 className={`${style["formheading"]}`}>How can I Help You?</h1>
                {/* <p className={`${style["formsubheading"]}`}>
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                </p> */}
                <div className={`${style["inputgroup"]} inputgroup ${style["w-100"]}`}>
                  <label className={`${style["inputlable"]}`}>Your Name<span>*</span></label>
                  <div className={`${style["inputdiv"]}`}>
                    <input
                      className={`${style["input"]}`}
                      type="text"
                      name="name"
                      placeholder="Enter your name"
                      {...register("name", {
                        required: "Name is required",
                        pattern: {
                          value: /\p{L}/gu,
                          message: "At least one alphabet character is required",
                        },
                      })}
                    />
                  </div>
                  <div id="name_error" className={`${style["error"]}`}>
                    {errors.name?.message}
                  </div>
                </div>
                <div className={`${style["inputgroup"]} inputgroup ${style["w-100"]}`}>
                  <label className={`${style["inputlable"]}`}>Your Email<span>*</span></label>

                  <div className={`${style["inputdiv"]}`}>
                    <input
                      className={`${style["input"]}`}
                      type="email"
                      name="email"
                      placeholder="Enter your email"
                      {...register("email", {
                        required: "Email is required",
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,}$/i,
                          message: "Email is not valid",
                        },
                      })}
                    />
                  </div>
                  <div id="email_error" className={`${style["error"]}`}>
                    {errors.email?.message}
                  </div>
                </div>
                <div className={`${style["inputgroup"]} inputgroup ${style["w-50"]}`}>
                  <label className={`${style["inputlable"]}`}>Mobile Number<span>*</span></label>
                  <div className={`${style["inputdiv"]} ${style["w-100"]}`}>
                    {/* hidden input */}
                    <input
                      {...register("mobile")}
                      type="hidden"
                      className={style["hidden"]}
                      id="contact_us_mobile_number"
                      value={phoneNumber}
                      name="mobile"
                    />
                    {/* hidden input */}
                    {countryCode && (
                      <IntlTelInput
                        // type="tel"
                        numberType={"MOBILE"}
                        id="mobile_contact"
                        preferredCountries={["us","gb","in"]}
                        autoPlaceholder="false"
                        inputClassName={`contact-us-phone ${style["input"]} `}
                        // initialCountry="auto"
                        value={phoneNumber}
                        defaultCountry={countryCode}
                        // autoCountryLoaded
                        // geoIpLookup={true}
                        onPhoneNumberChange={onChange}
                        onPhoneNumberBlur={onChange}
                        // format
                        // telInputProps={isValidNumber}
                      />
                    )}
                    <div id="mobile-emsg" className={`${style["error"]}`}>
                      {!isValidNum && "Please enter valid phone number"}
                    </div>
                  </div>
                  {errors.country && <span className={`${style["error"]}`}>{errors.country.join(", ")}</span>}
                </div>
                <div className={`${style["inputgroup"]} inputgroup ${style["w-50"]}`}>
                  <label className={`${style["inputlable"]}`}>Institute<span>*</span></label>
                  <div className={`${style["inputdiv"]}`}>
                    <input
                      className={`${style["input"]}`}
                      type="text"
                      name="organization"
                      placeholder="Institute Name"
                      {...register("organization", {
                        required: "Company is required",
                        pattern: {
                          value: /\p{L}/gu,
                          message: "At least one alphabet character is required",
                        },
                      })}
                    />
                  </div>
                  <div id="company_error" className={`${style["error"]}`}>
                    {errors.organization?.message}
                  </div>
                </div>
                <div className={`${style["inputgroup"]} inputgroup ${style["w-100"]}`}>
                  <label className={`${style["inputlable"]}`}>Message<span>*</span></label>
                  <div className={`${style["inputdiv"]}`}>
                    <textarea
                      className={`${style["input"]} alphabetcheck`}
                      id="message_contact"
                      type="text"
                      row={15}
                      name="message"
                      placeholder="Write your message"
                      {...register("message", {
                        required: "Message is required",
                        pattern: {
                          value: /\p{L}/gu,
                          message: "At least one alphabet character is required",
                        },
                      })}
                    ></textarea>
                  </div>
                  <div className={`${style["error"]}`}>{errors.message?.message}</div>
                </div>
                {/* Add other form fields here */}
                <div className={`${style["formbottompart"]}`}>
                  <button
                    ref={submitBtn}
                    className={`${style["buttonsubmit"]} commonformbtn`}
                    type="button"
                    onClick={onSubmit}
                  >
                    Send Message
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default ServiceForm;
